import React from 'react';

export default function Graph309(props) {

    let {a, b, c, d} = props.data;
    
    props.board.create('functiongraph',[function(x){return a*Math.abs(x - b) + c*x + d}],{strokeColor:'black',highlightStrokeColor:'black'});
    
    return <></>
}